import { is_expired_session_error } from './AuthInterceptor';

// The message to show the user for a failed request, or '' when there is nothing to show. Only a 4xx response's
// message is shown: those are the backend's deliberate answers to the user (invalid email or password, site
// already added, not found). A 5xx response's message is an internal error (a code failure, a stack message) and
// is never shown, and neither is a network error; both get the fallback the caller gives. An expired session gets
// no message at all: the user is already on their way to the login screen.
export const get_user_error_message = (error, fallback)=>{
	if(is_expired_session_error(error)){
		return '';
	}

	const response = error ? error.response : null;
	if(!response || (response.status < 400) || (response.status >= 500)){
		return fallback;
	}

	if(response.data && (typeof response.data.message === 'string') && (response.data.message.length > 0)){
		return response.data.message;
	}

	return fallback;
};
